<template>
  <div class="cf-padding-top-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Select a Favorite Location
    </Teleport>

    <cf-location-selector
      :is-selecting="isSelecting"
      :show-store-validations="false"
      :selected-store-id="selectedStoreId"
      inline-search-results
      @select="handleSelectFavoriteStore"
    />
  </div>
</template>


<script>
  import logger from '@/services/logger';

  import CfLocationSelector from '@/view/components/globals/cf-location-selector/index.vue';


  export default {
    name: 'SelectFavoriteStore',

    components: {
      CfLocationSelector
    },

    props: {
      selectedStoreId: {
        type: Number,
        default: null
      },

      onFavoriteStoreSelection: {
        type: Function,
        required: true
      }
    },

    data: () => ({
      isSelecting: false
    }),

    methods: {
      async handleSelectFavoriteStore(selectedStore) {
        try {
          this.isSelecting = true;
          await this.onFavoriteStoreSelection(selectedStore);
          this.$closeModal('selectFavoriteStore');
        }
        catch (error) {
          logger.error(error);
        }
        finally {
          this.isSelecting = false;
        }
      }
    }
  };
</script>
